module.exports = __webpack_public_path__ + "img/back.13dff82b.png";